import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import AdminSidebar from '../components/Sidebar';
import AdminDashboard from './Dashboard';
import AdminUsers from './Users';
import AdminVideos from './Videos';
import {
  AdminPayments, AdminSubscriptions,
  AdminReports, AdminInvestmentQueries
} from './Other';
import { useAuth } from '../context/AuthContext';

export default function AdminLayout() {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (!user || user.role !== 'admin') return <Navigate to="/" />;

  return (
    <div className="min-h-screen flex">
      <AdminSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="sidebar-content flex-1 min-w-0">
        <header className="sticky top-0 z-30 bg-[var(--color-bg)]/95 border-b border-[var(--glass-border)] backdrop-blur-md h-[65px]">
          <div className="flex items-center gap-3 px-4 sm:px-6 h-14">
            <button onClick={() => setSidebarOpen(true)}
              className="lg:hidden p-2 rounded-lg text-[var(--color-muted)] hover:text-[var(--color-text)] transition-colors">
              <Menu className="w-5 h-5" />
            </button>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-bold uppercase tracking-widest text-[var(--color-muted)]">Stone Bench Admin</p>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-full flex items-center justify-center text-white text-xs font-bold shrink-0" style={{ background: 'var(--color-accent)' }}>
                {user.email?.charAt(0).toUpperCase()}
              </div>
            </div>
          </div>
        </header>
        <main className="p-4 sm:p-6 lg:p-8">
          <Routes>
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="videos" element={<AdminVideos />} />
            <Route path="payments" element={<AdminPayments />} />
            <Route path="subscriptions" element={<AdminSubscriptions />} />
            <Route path="investment-queries" element={<AdminInvestmentQueries />} />
            <Route path="reports" element={<AdminReports />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
